module.exports = __webpack_public_path__ + "assets/img/5_1355_big.121e3bef.jpg";